import { render, staticRenderFns } from "./V3Table.vue?vue&type=template&id=3b6c8dd7&scoped=true&"
import script from "./V3Table.vue?vue&type=script&lang=js&"
export * from "./V3Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c8dd7",
  null
  
)

export default component.exports